import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const InputWrapper = styled.input`  
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
`;

const InputWithMemory = ({ initialValue, onChange, ...props }) => {
    const [value, updateValue] = useState(initialValue);
    const [focused, toggleFocus] = useState(false);
    const [cache, saveCache] = useState(null);
    useEffect(() => {
        if (focused) return onChange(value);
    }, [value]);

    useEffect(() => {
        updateValue(initialValue);
        saveCache(initialValue);
    }, [initialValue]);

    useEffect(() => {
        updateValue(focused ? '' : cache);
    }, [focused]);

    return (
        <>
            <InputWrapper
                value={value}
                onChange={(e) => updateValue(e.target.value)}
                onFocus={() => toggleFocus(!focused)}
                onBlur={() => toggleFocus(!focused)}
                {...props}
            />
        </>
    );
};

InputWithMemory.propTypes = {
    initialValue: PropTypes.string,
    onChange: PropTypes.func
};

export default InputWithMemory;
